import React from 'react';
import { motion } from 'motion/react';
import { Zap, Clipboard, MapPin, ScanText, Paperclip, Film, Mail, List } from 'lucide-react';
import { powerFeatures } from '../data/mock';

const iconMap = {
  Zap,
  Clipboard,
  MapPin,
  ScanText,
  Paperclip,
  Film,
  Mail,
  List
};

const PowerFeatures = () => {
  const springConfig = {
    type: "spring",
    damping: 80,
    stiffness: 400,
    mass: 1
  };

  return (
    <section className="py-24 bg-gray-50">
      <div className="container">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={springConfig}
          className="text-center mb-16"
        >
          <h2 
            className="heading-large mb-4"
            style={{
              fontSize: 'clamp(32px, 4vw, 48px)',
              fontWeight: 600,
              color: '#0A0A0A',
              letterSpacing: '-0.01em'
            }}
          >
            More Than Just a Keyboard
          </h2>
          <p 
            className="body-large max-w-2xl mx-auto"
            style={{
              fontSize: '18px',
              color: '#3C3B3D',
              lineHeight: 1.6
            }}
          >
            Advanced tools built right into your keyboard — no extra apps needed
          </p>
        </motion.div>

        {/* Features Grid */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6">
          {powerFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <motion.div
                key={feature.id}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ ...springConfig, delay: index * 0.1 }}
                whileHover={{ scale: 1.02, transition: { duration: 0.2 } }}
                className="bg-white rounded-2xl p-6 shadow-sm hover:shadow-xl transition-all border border-gray-200 relative"
              >
                {/* NEW Badge */}
                {feature.isNew && (
                  <div className="absolute top-4 right-4">
                    <span className="px-2 py-1 bg-gradient-to-r from-orange-400 to-pink-400 text-white text-xs font-semibold rounded-full">
                      NEW
                    </span>
                  </div>
                )}
                
                <div className="flex items-start gap-4">
                  {/* Icon */}
                  <div 
                    className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                    style={{
                      background: 'linear-gradient(135deg, #FF8C42 0%, #FF6B9D 100%)'
                    }}
                  >
                    <Icon className="w-6 h-6 text-white" />
                  </div>

                  {/* Content */}
                  <div className="flex-1 pr-8">
                    <h3 
                      className="heading-medium mb-2"
                      style={{
                        fontSize: '18px',
                        fontWeight: 600,
                        color: '#0A0A0A'
                      }}
                    >
                      {feature.title}
                    </h3>
                    <p 
                      className="body-standard"
                      style={{
                        fontSize: '14px',
                        color: '#757478',
                        lineHeight: 1.6
                      }}
                    >
                      {feature.description}
                    </p>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default PowerFeatures;
